import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage = 'Hola, me interesa la propuesta de alianza Artesco y TNO Network para Punto de Fe (El Arte de Plasmar tu Fe - Aliado de Bienestar).';

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom={2}
      >
        ¿Listo para ser el Aliado de Bienestar en Punto de Fe?
      </Box>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 640, mx: 'auto' }}
      >
        Conecta a Artesco con Punto de Fe, Margarita Toledo y el ecosistema TNO. Porque cada palabra escrita es una semilla de esperanza que comienza a brotar.
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          component="img"
          src="/images/margaritaencabina.png"
          alt="Margarita Toledo en cabina - Punto de Fe | TNO Network"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            boxShadow: 3,
            objectFit: 'cover',
            mb: 4,
          }}
        />
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          gap={2}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
              window.open(url, '_blank');
            }}
          >
            Contactar para propuesta Artesco
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Artesco & Punto de Fe | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
